export class TaellevaerkType {
    public enhedType: string;
    public beskrivelse: string;
    public enhed: string;
    public decimaler: number;
}
